import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, matchPath, Outlet } from 'react-router-dom';
import Navbar from './components/Navbar';
import GlobalNotice from './components/GlobalNotice';
import NoticeDetail from './pages/NoticeDetail';
import NoticeList from './pages/NoticeList';
import DetailNavbar from './components/DetailNavbar';
import CommunityNavbar from "./components/CommunityNavbar";
import Footer from './components/Footer';
import MyPage from './pages/MyPage';

import AddressList from './pages/AddressList';
import AddressAdd from './pages/AddressAdd';
import AddressEdit from './pages/AddressEdit';

import Coupon from './pages/Coupon';

import Claims from './pages/Claims';
import ClaimRequest from './pages/ClaimRequest';

import Wishlist from './pages/Wishlist';
import Reviews from './pages/Reviews';
import ReviewEdit from './pages/ReviewEdit';
import ReviewWrite from './pages/ReviewWrite';
import QnaList from './pages/QnaList';

import ProductList from './pages/ProductList';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';

import Login from './pages/Login';
import Register from './pages/Register';

import OrderList from './pages/OrderList';
import OrderDetail from './pages/OrderDetail';
import OrdersByStatus from './pages/OrdersByStatus';

import OrderNow from './pages/OrderNow';
import OrderSelected from './pages/OrderSelected';

import PickupCalendar from './pages/PickupCalendar';

import PayNow from './pages/PayNow';
import PaySelected from './pages/PaySelected';

import FailNow from './pages/FailNow';
import FailSelected from './pages/FailSelected';
import SuccessSelected from './pages/SuccessSelected';
import SuccessNow from './pages/SuccessNow';

import Search from './pages/Search';
import PlatformHome from './pages/PlatformHome';

import TermsPage from './pages/Termspage';
import PrivacyPage from './pages/PrivacyPage';
import RefundPolicyPage from './pages/RefundPolicyPage';

/* 테이블오더 */
import TableCart from './pages/table_order/TableCart';
import TableOrder from './pages/table_order/TableOrder';

/* 키오스크 */
import KioskLogin from './pages/kiosk/KioskLogin';
import KioskHome from './pages/kiosk/KioskHome';
import KioskCart from './pages/kiosk/KioskCart';
import MobileStart from './pages/kiosk/MobileStart';
import MobileCart from './pages/kiosk/MobileCart';
import MobileCheckout from './pages/kiosk/MobileCheckout';
import MobileSuccessNow from './pages/kiosk/MobileSuccessNow';
import GuestOrderDetail from "./pages/kiosk/GuestOrderDetail";
import ReceiptPrint from "./pages/kiosk/ReceiptPrint";
import GuestOrderLookup from "./pages/kiosk/GuestOrderLookup";

/* 포스 */
import PosPage from './pages/pos/PosPage';
import PosManagePage from './pages/pos/PosManagePage';
import PosMenuPage from './pages/pos/PosMenuPage';
import PosCartPage from './pages/pos/PosCartPage';
import AdminKioskOrderViewPage from './pages/pos/AdminKioskOrderViewPage';

/* 주방 */
import KitchenManage from './pages/kitchen/KitchenManage';
import KitchenOrders from './pages/kitchen/KitchenOrders';

/* 셀러 */
import SellerManage from './seller/SellerManage';
import SellerDashboard from './seller/SellerDashboard';
import SellerCategoryList from './seller/SellerCategoryList';
import SellerCategoryEdit from './seller/SellerCategoryEdit';
import SellerCategoryAdd from './seller/SellerCategoryAdd';
import SellerProductList from './seller/SellerProductList';
import SellerProductAdd from './seller/SellerProductAdd';
import SellerProductView from './seller/SellerProductView';
import SellerProductEdit from './seller/SellerProductEdit';
import SellerStock from './seller/SellerStock';
import SellerHeroSlides from './seller/SellerHeroSlides';
import SellerNoticeAdd from './seller/SellerNoticeAdd';
import SellerNoticeEdit from './seller/SellerNoticeEdit';
import SellerNoticeList from './seller/SellerNoticeList';
import SellerOrders from './seller/SellerOrders';
import SellerOrderView from './seller/SellerOrderView';
import SellerOrderLogs from './seller/SellerOrderLogs';
import SellerPickupEdit from './seller/SellerPickupEdit';
import SellerDeliveryEdit from './seller/SellerDeliveryEdit';
import SellerClaimList from './seller/SellerClaimList';
import SellerCouponManage from './seller/SellerCouponManage';
import SellerCouponEdit from './seller/SellerCouponEdit';
import SellerMemberList from './seller/SellerMemberList';
import SellerMemberDetail from './seller/SellerMemberDetail';
import SellerReview from './seller/SellerReview';
import SellerQnaList from './seller/SellerQnaList';
import SellerQnaEdit from './seller/SellerQnaEdit';
import SellerQnaView from './seller/SellerQnaView';
import SellerLiveOrders from './seller/SellerLiveOrders';
import SellerKioskOrderView from './seller/SellerKioskOrderView';
import SellerTableQ from './seller/SellerTableQ';
import SellerWaitingQr from './seller/SellerWaitingQr';
import SellerWaitingManage from './seller/SellerWaitingManage';
import PosFloorEditor from './pages/pos/PosFloorEditor';
import WaitingRegister from './pages/WaitingRegister';
import WaitingStatus from './pages/WaitingStatus';
import SellerProductOption from './seller/SellerProductOption';

import SellerDeliverySetting from './seller/SellerDeliverySetting';

import SellerSmartfarmList from './seller/SellerSmartfarmList';
import SellerSmartfarmForm from './seller/SellerSmartfarmForm';
import SellerSmartfarmRequestList from './seller/SellerSmartfarmRequestList';

import Esp32Test from './seller/Esp32Test';
import Esp32Builder, { NutrientEntry } from './seller/Esp32Builder';
import Esp32NutrientBuilder from './seller/Esp32NutrientBuilder';

import SellerSmartfarm2D from './seller/SellerSmartfarm2D';
import SellerSmartfarmPreview from './seller/SellerSmartfarmPreview';
import SellerSmartfarm3D from './seller/SellerSmartfarm3D';
import SellerSmartfarm3DPreview from './seller/SellerSmartfarm3DPreview';

/* 플랫폼 관리자 */
import PlatformAdminLogin from './platform_admin/PlatformAdminLogin';
import PlatformAdminIndex from './platform_admin/PlatformAdminIndex';
import PlatformAdminClaims from './platform_admin/PlatformAdminClaims';
import PlatformAdminNotices from './platform_admin/PlatformAdminNotices';
import PlatformAdminNoticeAdd from './platform_admin/PlatformAdminNoticeAdd';
import PlatformAdminNoticeEdit from './platform_admin/PlatformAdminNoticeEdit';
import PlatformAdminOrders from './platform_admin/PlatformAdminOrders';
import PlatformAdminOrderView from './platform_admin/PlatformAdminOrderView';
import PlatformAdminSellers from './platform_admin/PlatformAdminSellers';
import PlatformAdminSellerAdd from './platform_admin/PlatformAdminSellerAdd';
import PlatformAdminSellerEdit from './platform_admin/PlatformAdminSellerEdit';
import PlatformAdminShops from './platform_admin/PlatformAdminShops';
import PlatformAdminShopView from './platform_admin/PlatformAdminShopView';

/* 스마트팜 */
import BathroomDashboard from './pages/BathroomDashboard/BathroomDashboard';
import MemberSmartfarm from './pages/MemberSmartFarm';
import SmartfarmRequest from './pages/SmartfarmRequest';
import MemberSmartfarm3D from './pages/MemberSmartfarm3D';

/* 영농일지 */
import FarmDiaryDashboard from './pages/FarmDiaryDashboardPage';
import FarmDiaryList from './pages/FarmDiaryListPage';
import FarmDiaryForm from './pages/FarmDiaryFormPage';
import FarmDiaryDetail from './pages/FarmDiaryDetailPage';
import FarmDiarySettings from './pages/FarmDiarySettingsPage';
import TodayFarmPage from './pages/TodayFarmPage';

/* 환경분석 */
import MemberSmartfarmAnalysis from './pages/MemberSmartfarmAnalysis';

/* 커뮤니티 */
import CommunityPage from './pages/CommunityPage';

import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { ShopProvider } from './context/ShopContext';
import { KioskAuthProvider } from './context/KioskAuthContext';
import { SellerAuthProvider } from './context/SellerAuthContext';
import { PosAuthProvider } from './context/PosAuthContext';
import { KitchenAuthProvider } from './context/KitchenAuthContext';
import { PlatformAuthProvider } from './context/PlatformAuthContext';

/* 쇼핑몰 전용 */
import PrivateRoute from "./routes/PrivateRoute";

/* 키오스크 전용 */
import KioskPrivateRoute from "./routes/KioskPrivateRoute";

/* 셀러 전용 */
import SellerPrivateRoute from './routes/SellerPrivateRoute';

/* 포스 전용 */
import PosPrivateRoute from './routes/PosPrivateRoute';

/* 키친 전용 */
import KitchenPrivateRoute from './routes/KitchenPrivateRoute';

/* 플랫폼 관리자 전용 */
import PlatformPrivateRoute from './routes/PlatformPrivateRoute';

import './App.css';
import axios from "axios";

axios.defaults.withCredentials = true;


/* =========================
   Kiosk Provider Layout
========================= */
function KioskProviderLayout() {
    return (
        <KioskAuthProvider>
            <Outlet />
        </KioskAuthProvider>
    );
}

/* =========================
   Seller Provider Layout
========================= */
function SellerProviderLayout() {
    return (
        <SellerAuthProvider>
            <Outlet />
        </SellerAuthProvider>
    );
}

/* =========================
   Pos Provider Layout
========================= */
function PosProviderLayout() {
    return (
        <PosAuthProvider>
            <Outlet />
        </PosAuthProvider>
    );
}

/* =========================
   Kitchen Provider Layout
========================= */
function KitchenProviderLayout() {
    return (
        <KitchenAuthProvider>
            <Outlet />
        </KitchenAuthProvider>
    );
}

/* =========================
   Platform Admin Provider Layout
========================= */
function PlatformProviderLayout() {
    return (
        <PlatformAuthProvider>
            <Outlet />
        </PlatformAuthProvider>
    );
}


/* =========================
   Navbar Switch
========================= */
function NavbarSwitch() {
    const location = useLocation();

    const hideNavbarPaths = [
        "/table/cart",
        "/table/order",
        "/kiosk/login",
        "/kiosk",
        "/kiosk/cart",
        "/kiosk/order",
        "/kiosk/mobile/start",
        "/kiosk/mobile/cart",
        "/kiosk/mobile/checkout",
        "/kiosk/mobile/success",
        "/kiosk/guest-order-detail",
        "/kiosk/receipt-print",
        "/kiosk/guest-order-lookup",
        "/pos",
        "/pos/manage",
        "/pos/menu",
        "/pos/cart",
        "/pos/admin-kiosk-order-view",
        "/seller/manage",
        "/seller",
        "/seller/category/list",
        "/seller/category/add",
        "/seller/category/edit",
        "/seller/product/list",
        "/seller/product/add",
        "/seller/product/view",
        "/seller/product/edit",
        "/seller/stock",
        "/seller/hero/slides",
        "/seller/notices",
        "/seller/notices/add",
        "/seller/notices/edit",
        "/seller/orders",
        "/seller/order/view",
        "/seller/order/logs",
        "/seller/pickup/edit",
        "/seller/delivery/edit",
        "/seller/claim/list",
        "/seller/coupon/manage",
        "/seller/coupon/edit/:couponId",
        "/seller/member/list",
        "/seller/member/detail",
        "/seller/review",
        "/seller/qna/list",
        "/seller/qna/edit",
        "/seller/qna/view",
        "/seller/kiosk/orders",
        "/seller/kiosk/order/view",
        "/seller/table/q",
        "/seller/product/options/:product_id",
        "/seller/smartfarm",
        "/seller/smartfarm/add",
        "/seller/smartfarm/edit",
        "/seller/smartfarm/requests",
        "/seller/smartfarm/esp32",
        "/seller/smartfarm/esp32/builder",
        "/seller/smartfarm/esp32/nutrient-builder",
        "/seller/smartfarm/3d",
        "/seller/smartfarm/3d/preview",
        "/smartfarm/3d",
        "/kitchen/manage",
        "/kitchen",
        "/platform_admin/login",
        "/platform_admin",
        "/platform_admin/claims",
        "/platform_admin/notices",
        "/platform_admin/notices/add",
        "/platform_admin/notices/edit",
        "/platform_admin/orders",
        "/platform_admin/order_view",
        "/platform_admin/sellers",
        "/platform_admin/seller_add",
        "/platform_admin/seller_edit",
        "/platform_admin/shops",
        "/platform_admin/shop_view",
        "/pos/floor/editor",
        "/seller/waiting/qr",
        "/seller/waiting/manage",
        "/waiting/register",
        "/waiting/status",
        "/seller/delivery/setting"
    ];

    const shouldHideNavbar = hideNavbarPaths.some((path) =>
        matchPath(path, location.pathname)
    );

    if (shouldHideNavbar) return null;

    const isCommunity = location.pathname.startsWith("/community");
    const isDetail =
        location.pathname === "/shop" ||
        matchPath("/product/:id", location.pathname) ||
        matchPath("/category/:id", location.pathname);
    
    if (isCommunity) {
        return <CommunityNavbar />;
    }

    return isDetail ? <DetailNavbar /> : <Navbar />;
}


/* =========================
   Footer Switch
========================= */
function FooterSwitch() {
    const location = useLocation();

    const hideFooterPaths = [
        "/mypage",
        "/smartfarm",
        "/farm-diary",
        "/today-farm",
        "/farm-diary",
        "/farm-diary/list",
        "/farm-diary/write",
        "/farm-diary/detail/:diaryId",
        "/farm-diary/edit/:diaryId",
        "/farm-diary/settings",
        "/community",
        "/address/list",
        "/address/add",
        "/address/edit/:id",
        "/coupon",
        "/claim",
        "/claim/request",
        "/wishlist",
        "/reviews",
        "/review/edit/:reviewId",
        "/review/write",
        "/qna",
        "/cart",
        "/seller/notices",
        "/seller/notices/add",
        "/seller/notices/edit",
        "/order/list",
        "/order/detail",
        "/order/status",
        "/order/now",
        "/order/selected",
        "/pickup/calendar",
        "/pay/now",
        "/pay/selected",
        "/product/:id",
        "/fail/now",
        "/fail/selected",
        "/success/selected",
        "/success/now",
        "/login/:social",
        "/table/cart",
        "/table/order",
        "/kiosk/login",
        "/kiosk",
        "/kiosk/cart",
        "/kiosk/order",
        "/kiosk/mobile/start",
        "/kiosk/mobile/cart",
        "/kiosk/mobile/checkout",
        "/kiosk/mobile/success",
        "/kiosk/guest-order-detail",
        "/kiosk/receipt-print",
        "/kiosk/guest-order-lookup",
        "/pos",
        "/pos/manage",
        "/pos/menu",
        "/pos/cart",
        "/pos/admin-kiosk-order-view",
        "/seller/manage",
        "/seller",
        "/seller/category/list",
        "/seller/category/add",
        "/seller/category/edit",
        "/seller/product/list",
        "/seller/product/add",
        "/seller/product/view",
        "/seller/product/edit",
        "/seller/stock",
        "/seller/hero/slides",
        "/seller/orders",
        "/seller/order/view",
        "/seller/order/logs",
        "/seller/pickup/edit",
        "/seller/delivery/edit",
        "/seller/claim/list",
        "/seller/coupon/manage",
        "/seller/coupon/edit/:couponId",
        "/seller/member/list",
        "/seller/member/detail",
        "/seller/review",
        "/seller/qna/list",
        "/seller/qna/edit",
        "/seller/qna/view",
        "/seller/kiosk/orders",
        "/seller/kiosk/order/view",
        "/seller/table/q",
        "/seller/product/options/:product_id",
        "/seller/smartfarm",
        "/seller/smartfarm/add",
        "/seller/smartfarm/edit",
        "/seller/smartfarm/requests",
        "/seller/smartfarm/esp32",
        "/seller/smartfarm/esp32/builder",
        "/seller/smartfarm/esp32/nutrient-builder",
        "/seller/smartfarm/3d",
        "/seller/smartfarm/3d/preview",
        "/smartfarm/3d",
        "/kitchen/manage",
        "/kitchen",
        "/platform_admin/login",
        "/platform_admin",
        "/platform_admin/claims",
        "/platform_admin/notices",
        "/platform_admin/notices/add",
        "/platform_admin/notices/edit",
        "/platform_admin/orders",
        "/platform_admin/order_view",
        "/platform_admin/sellers",
        "/platform_admin/seller_add",
        "/platform_admin/seller_edit",
        "/platform_admin/shops",
        "/platform_admin/shop_view",
        "/pos/floor/editor",
        "/seller/waiting/qr",
        "/seller/waiting/manage",
        "/waiting/register",
        "/waiting/status",
        "/seller/delivery/setting"
    ];

    const shouldHideFooter = hideFooterPaths.some((path) =>
        matchPath(path, location.pathname)
    );

    if (shouldHideFooter) return null;

    return <Footer />;
}


function App() {
    return (
        <AuthProvider>
            <ShopProvider>
                <CartProvider>
                    <Router>
                        <GlobalNotice />
                        <NavbarSwitch />
                        <main style={{ marginTop: '0px' }}>
                            <Routes>
                                {/* =========================
                                   쇼핑몰 영역
                                ========================= */}
                                <Route path="/" element={<PlatformHome />} />
                                <Route path="/notice/:id" element={<NoticeDetail />} />
                                <Route path="/notice" element={<NoticeList />} />
                                <Route path="/shop" element={<ProductList />} />
                                <Route path="/category/:id" element={<ProductList />} />
                                <Route path="/mypage" element={<PrivateRoute><MyPage /></PrivateRoute>} />

                                <Route path="/address/list" element={<PrivateRoute><AddressList /></PrivateRoute>} />
                                <Route path="/address/add" element={<PrivateRoute><AddressAdd /></PrivateRoute>} />
                                <Route path="/address/edit/:id" element={<PrivateRoute><AddressEdit /></PrivateRoute>} />

                                <Route path="/coupon" element={<PrivateRoute><Coupon /></PrivateRoute>} />

                                <Route path="/claim" element={<PrivateRoute><Claims /></PrivateRoute>} />
                                <Route path="/claim/request" element={<PrivateRoute><ClaimRequest /></PrivateRoute>} />

                                <Route path='/wishlist' element={<PrivateRoute><Wishlist /></PrivateRoute>} />
                                <Route path='/reviews' element={<PrivateRoute><Reviews /></PrivateRoute>} />
                                <Route path='/review/edit/:reviewId' element={<PrivateRoute><ReviewEdit /></PrivateRoute>} />
                                <Route path='/review/write' element={<PrivateRoute><ReviewWrite /></PrivateRoute>} />
                                <Route path='/qna' element={<PrivateRoute><QnaList /></PrivateRoute>} />

                                <Route path="/product/:id" element={<ProductDetail />} />
                                <Route path="/cart" element={<PrivateRoute><Cart /></PrivateRoute>} />

                                <Route path="/order/list" element={<PrivateRoute><OrderList /></PrivateRoute>} />
                                <Route path="/order/detail" element={<PrivateRoute><OrderDetail /></PrivateRoute>} />
                                <Route path="/order/status" element={<PrivateRoute><OrdersByStatus /></PrivateRoute>} />

                                <Route path="/order/now" element={<PrivateRoute><OrderNow /></PrivateRoute>} />
                                <Route path="/order/selected" element={<PrivateRoute><OrderSelected /></PrivateRoute>} />

                                <Route path="/pickup/calendar" element={<PrivateRoute><PickupCalendar /></PrivateRoute>} />

                                <Route path="/pay/now" element={<PrivateRoute><PayNow /></PrivateRoute>} />
                                <Route path="/pay/selected" element={<PrivateRoute><PaySelected /></PrivateRoute>} />

                                <Route path="/fail/now" element={<PrivateRoute><FailNow /></PrivateRoute>} />
                                <Route path="/fail/selected" element={<PrivateRoute><FailSelected /></PrivateRoute>} />
                                <Route path="/success/selected" element={<PrivateRoute><SuccessSelected /></PrivateRoute>} />
                                <Route path="/success/now" element={<PrivateRoute><SuccessNow /></PrivateRoute>} />

                                <Route path="/join/agreement" element={<TermsPage />} />
                                <Route path="/join/jungbo" element={<PrivacyPage />} />
                                <Route path="/refund-policy" element={<RefundPolicyPage />} />
                                
                                <Route path="/search" element={<Search />} />

                                {/* 스마트팜 */}
                                <Route path="/BathroomDashboard" element={<BathroomDashboard />} />

                                <Route path="/smartfarm" element={<PrivateRoute><MemberSmartfarm /></PrivateRoute>} />
                                <Route path="/smartfarm/3d" element={<PrivateRoute><MemberSmartfarm3D /></PrivateRoute>} />
                                <Route path="/smartfarm/request" element={<PrivateRoute><SmartfarmRequest /></PrivateRoute>} />
                                
                                {/* 영농일지 */}
                                <Route path="/farm-diary" element={<PrivateRoute><FarmDiaryDashboard /></PrivateRoute>} />
                                <Route path="/farm-diary/list" element={<PrivateRoute><FarmDiaryList /></PrivateRoute>} />
                                <Route path="/farm-diary/write" element={<PrivateRoute><FarmDiaryForm /></PrivateRoute>} />
                                <Route path="/farm-diary/detail/:diaryId" element={<PrivateRoute><FarmDiaryDetail /></PrivateRoute>} />
                                <Route path="/farm-diary/edit/:diaryId" element={<PrivateRoute><FarmDiaryForm /></PrivateRoute>} />
                                <Route path="/farm-diary/settings" element={<PrivateRoute><FarmDiarySettings /></PrivateRoute>} />

                                <Route path="/today-farm" element={<PrivateRoute><TodayFarmPage /></PrivateRoute>} />

                                {/* 환경분석 */}
                                <Route path="/smartfarm/analysis" element={<PrivateRoute><MemberSmartfarmAnalysis /></PrivateRoute>} />

                                {/* 커뮤니티 */}
                                <Route path="/community" element={<CommunityPage />} />
                                <Route path="/community/posts/:postId" element={<CommunityPage />} />
                                <Route path="/community/write" element={<PrivateRoute><CommunityPage /></PrivateRoute>} />
                                <Route path="/community/posts/:postId/edit" element={<PrivateRoute><CommunityPage /></PrivateRoute>} />
                                <Route path="/community/bookmarks" element={<PrivateRoute><CommunityPage /></PrivateRoute>} />
                                <Route path="/community/my-posts" element={<PrivateRoute><CommunityPage /></PrivateRoute>} />

                                {/* 쇼핑몰 로그인 */}
                                <Route path="/login" element={<Login />} />
                                <Route path="/login/:social" element={<Login />} />
                                <Route path="/register" element={<Register />} />

                                {/* =========================
                                   테이블 오더
                                ========================= */}
                                <Route path="/table/cart" element={<TableCart />} />
                                <Route path="/table/order" element={<TableOrder />} />

                                {/* =========================
                                   키오스크 영역
                                ========================= */}
                                <Route element={<KioskProviderLayout />}>
                                    <Route path="/kiosk/login" element={<KioskLogin />} />
                                    <Route path="/kiosk" element={<KioskPrivateRoute><KioskHome /></KioskPrivateRoute>} />
                                    <Route path="/kiosk/cart" element={<KioskPrivateRoute><KioskCart /></KioskPrivateRoute>} />
                                    <Route path="/kiosk/mobile/start" element={<MobileStart />} />
                                    <Route path="/kiosk/mobile/cart" element={<MobileCart />} />
                                    <Route path="/kiosk/mobile/checkout" element={<MobileCheckout />} />
                                    <Route path="/kiosk/mobile/success" element={<MobileSuccessNow />} />
                                    <Route path="/kiosk/guest-order-detail" element={<GuestOrderDetail />} />
                                    <Route path="/kiosk/receipt-print" element={<ReceiptPrint />} />
                                    <Route path="/kiosk/guest-order-lookup" element={<GuestOrderLookup />} />
                                </Route>

                                {/* =========================
                                   포스
                                ========================= */}
                                <Route element={<PosProviderLayout />}>
                                    <Route path="/pos/manage" element={<PosManagePage />} />
                                    <Route path="/pos" element={<PosPrivateRoute><PosPage /></PosPrivateRoute>} />
                                    <Route path="/pos/menu" element={<PosPrivateRoute><PosMenuPage /></PosPrivateRoute>} />
                                    <Route path="/pos/cart" element={<PosPrivateRoute><PosCartPage /></PosPrivateRoute>} />
                                    <Route path="/pos/admin-kiosk-order-view" element={<PosPrivateRoute><AdminKioskOrderViewPage /></PosPrivateRoute>} />
                                </Route>

                                {/* =========================
                                   주방
                                ========================= */}
                                <Route element={<KitchenProviderLayout />}>
                                    <Route path="/kitchen/manage" element={<KitchenManage />} />
                                    <Route path="/kitchen" element={<KitchenPrivateRoute><KitchenOrders /></KitchenPrivateRoute>} />
                                </Route>

                                {/* =========================
                                   셀러 영역
                                ========================= */}
                                <Route element={<SellerProviderLayout />}>
                                    <Route path="/seller/manage" element={<SellerManage />} />
                                    <Route path="/seller" element={<SellerPrivateRoute><SellerDashboard /></SellerPrivateRoute>} />
                                    <Route path="/seller/category/list" element={<SellerPrivateRoute><SellerCategoryList /></SellerPrivateRoute>} />
                                    <Route path="/seller/category/add" element={<SellerPrivateRoute><SellerCategoryAdd /></SellerPrivateRoute>} />
                                    <Route path="/seller/category/edit" element={<SellerPrivateRoute><SellerCategoryEdit /></SellerPrivateRoute>} />
                                    <Route path="/seller/product/list" element={<SellerPrivateRoute><SellerProductList /></SellerPrivateRoute>} />
                                    <Route path="/seller/product/add" element={<SellerPrivateRoute><SellerProductAdd /></SellerPrivateRoute>} />
                                    <Route path="/seller/product/view" element={<SellerPrivateRoute><SellerProductView /></SellerPrivateRoute>} />
                                    <Route path="/seller/product/edit" element={<SellerPrivateRoute><SellerProductEdit /></SellerPrivateRoute>} />
                                    <Route path="/seller/stock" element={<SellerPrivateRoute><SellerStock /></SellerPrivateRoute>} />
                                    <Route path="/seller/hero/slides" element={<SellerPrivateRoute><SellerHeroSlides /></SellerPrivateRoute>} />
                                    <Route path="/seller/notices" element={<SellerPrivateRoute><SellerNoticeList /></SellerPrivateRoute>} />
                                    <Route path="/seller/notices/add" element={<SellerPrivateRoute><SellerNoticeAdd /></SellerPrivateRoute>} />
                                    <Route path="/seller/notices/edit" element={<SellerPrivateRoute><SellerNoticeEdit /></SellerPrivateRoute>} />
                                    <Route path="/seller/orders" element={<SellerPrivateRoute><SellerOrders /></SellerPrivateRoute>} />
                                    <Route path="/seller/order/view" element={<SellerPrivateRoute><SellerOrderView /></SellerPrivateRoute>} />
                                    <Route path="/seller/order/logs" element={<SellerPrivateRoute><SellerOrderLogs /></SellerPrivateRoute>} />
                                    <Route path="/seller/pickup/edit" element={<SellerPrivateRoute><SellerPickupEdit /></SellerPrivateRoute>} />
                                    <Route path="/seller/delivery/edit" element={<SellerPrivateRoute><SellerDeliveryEdit /></SellerPrivateRoute>} />
                                    <Route path="/seller/claim/list" element={<SellerPrivateRoute><SellerClaimList /></SellerPrivateRoute>} />
                                    <Route path="/seller/coupon/manage" element={<SellerPrivateRoute><SellerCouponManage /></SellerPrivateRoute>} />
                                    <Route path="/seller/coupon/edit/:couponId" element={<SellerPrivateRoute><SellerCouponEdit /></SellerPrivateRoute>} />
                                    <Route path="/seller/member/list" element={<SellerPrivateRoute><SellerMemberList /></SellerPrivateRoute>} />
                                    <Route path="/seller/member/detail" element={<SellerPrivateRoute><SellerMemberDetail /></SellerPrivateRoute>} />
                                    <Route path="/seller/review" element={<SellerPrivateRoute><SellerReview /></SellerPrivateRoute>} />
                                    <Route path="/seller/qna/list" element={<SellerPrivateRoute><SellerQnaList /></SellerPrivateRoute>} />
                                    <Route path="/seller/qna/edit" element={<SellerPrivateRoute><SellerQnaEdit /></SellerPrivateRoute>} />
                                    <Route path="/seller/qna/view" element={<SellerPrivateRoute><SellerQnaView /></SellerPrivateRoute>} />
                                    <Route path="/seller/kiosk/orders" element={<SellerPrivateRoute><SellerLiveOrders /></SellerPrivateRoute>} />
                                    <Route path="/seller/kiosk/order/view" element={<SellerPrivateRoute><SellerKioskOrderView /></SellerPrivateRoute>} />
                                    <Route path="/seller/table/q" element={<SellerPrivateRoute><SellerTableQ /></SellerPrivateRoute>} />
                                    <Route path="/seller/waiting/qr" element={<SellerPrivateRoute><SellerWaitingQr /></SellerPrivateRoute>} />
                                    <Route path="/seller/waiting/manage" element={<SellerPrivateRoute><SellerWaitingManage /></SellerPrivateRoute>} />
                                    <Route path="/pos/floor/editor" element={<SellerPrivateRoute><PosFloorEditor /></SellerPrivateRoute>} />
                                    <Route path="/waiting/register" element={<WaitingRegister />} />
                                    <Route path="/waiting/status" element={<SellerPrivateRoute><WaitingStatus /></SellerPrivateRoute>} />
                                    <Route path="/seller/delivery/setting" element={<SellerPrivateRoute><SellerDeliverySetting /></SellerPrivateRoute>} />
                                    <Route path="/seller/product/options/:product_id" element={<SellerPrivateRoute><SellerProductOption /></SellerPrivateRoute>} />

                                    <Route path="/seller/smartfarm" element={<SellerPrivateRoute><SellerSmartfarmList /></SellerPrivateRoute>} />
                                    <Route path="/seller/smartfarm/add" element={<SellerPrivateRoute><SellerSmartfarmForm /></SellerPrivateRoute>} />
                                    <Route path="/seller/smartfarm/edit" element={<SellerPrivateRoute><SellerSmartfarmForm /></SellerPrivateRoute>} />
                                    <Route path="/seller/smartfarm/requests" element={<SellerPrivateRoute><SellerSmartfarmRequestList /></SellerPrivateRoute>} />

                                    <Route path="/seller/smartfarm/esp32" element={<SellerPrivateRoute><Esp32Test /></SellerPrivateRoute>} />

                                    <Route path="/seller/smartfarm/esp32/builder" element={<SellerPrivateRoute><Esp32Builder /></SellerPrivateRoute>} />
                                    <Route path="/seller/smartfarm/esp32/nutrient-builder" element={<SellerPrivateRoute><NutrientEntry /></SellerPrivateRoute>} />

                                    <Route path="/seller/smartfarm/2d" element={<SellerPrivateRoute><SellerSmartfarm2D /></SellerPrivateRoute>} />
                                    <Route path="/seller/smartfarm/preview" element={<SellerPrivateRoute><SellerSmartfarmPreview /></SellerPrivateRoute>} />
                                    <Route path="/seller/smartfarm/3d" element={<SellerPrivateRoute><SellerSmartfarm3D /></SellerPrivateRoute>} />
                                    <Route path="/seller/smartfarm/3d/preview" element={<SellerPrivateRoute><SellerSmartfarm3DPreview /></SellerPrivateRoute>} />
                                </Route>

                                {/* =========================
                                   플랫폼 관리자
                                ========================= */}
                                <Route element={<PlatformProviderLayout />}>
                                    <Route path="/platform_admin/login" element={<PlatformAdminLogin />} />
                                    <Route path="/platform_admin" element={<PlatformPrivateRoute><PlatformAdminIndex /></PlatformPrivateRoute>} />
                                    <Route path="/platform_admin/claims" element={<PlatformPrivateRoute><PlatformAdminClaims /></PlatformPrivateRoute>} />
                                    <Route path="/platform_admin/notices" element={<PlatformPrivateRoute><PlatformAdminNotices /></PlatformPrivateRoute>} />
                                    <Route path="/platform_admin/notices/add" element={<PlatformPrivateRoute><PlatformAdminNoticeAdd /></PlatformPrivateRoute>} />
                                    <Route path="/platform_admin/notices/edit" element={<PlatformPrivateRoute><PlatformAdminNoticeEdit /></PlatformPrivateRoute>} />
                                    <Route path="/platform_admin/orders" element={<PlatformPrivateRoute><PlatformAdminOrders /></PlatformPrivateRoute>} />
                                    <Route path="/platform_admin/order_view" element={<PlatformPrivateRoute><PlatformAdminOrderView /></PlatformPrivateRoute>} />
                                    <Route path="/platform_admin/sellers" element={<PlatformPrivateRoute><PlatformAdminSellers /></PlatformPrivateRoute>} />
                                    <Route path="/platform_admin/seller_add" element={<PlatformPrivateRoute><PlatformAdminSellerAdd /></PlatformPrivateRoute>} />
                                    <Route path="/platform_admin/seller_edit" element={<PlatformPrivateRoute><PlatformAdminSellerEdit /></PlatformPrivateRoute>} />
                                    <Route path="/platform_admin/shops" element={<PlatformPrivateRoute><PlatformAdminShops /></PlatformPrivateRoute>} />
                                    <Route path="/platform_admin/shop_view" element={<PlatformPrivateRoute><PlatformAdminShopView /></PlatformPrivateRoute>} />
                                </Route>
                            </Routes>
                        </main>
                        <FooterSwitch />
                    </Router>
                </CartProvider>
            </ShopProvider>
        </AuthProvider>
    );
}

export default App;